import { render, staticRenderFns } from "./EditCurrentUser.vue?vue&type=template&id=d6477ba0&"
import script from "./EditCurrentUser.ts?vue&type=script&lang=ts&"
export * from "./EditCurrentUser.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports